import { Injectable } from '@angular/core';
import {ToastService} from "./toast.service";
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ActionService {

  private actionsLoadedSource = new BehaviorSubject<boolean>(false);
  public actionsLoaded$ = this.actionsLoadedSource.asObservable();

  private userActions = new Set<string>();

  constructor(private toastService: ToastService) {
    // this.loadActions();
  }

  loadActions(): void {
    this.userActions.clear();
    let loadedSuccessfully = false

    try{

      const actionsJSON = localStorage.getItem("actions")

      if(actionsJSON) {
        const actions: string[] = JSON.parse(actionsJSON);

        if(Array.isArray(actions)){
          actions.forEach(action => this.userActions.add(action))
          loadedSuccessfully = true;
        }else{
          console.error("","Actions não é um array no localStorage")
        }
      }

    } catch(error){
      this.toastService.erro("", "Erro ao carregas as permissões, tente novamente.")
    } finally {
      this.actionsLoadedSource.next(true)
    }
  }

  can(actionName: string): boolean {
    if(!actionName) return false;

    return this.userActions.has(actionName);
  }

  clearPermissions(): void {
    this.userActions.clear();
  }

  get areActionLoaded(): boolean {
    return this.actionsLoadedSource.value;
  }
}
